var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-12",attrs:{"id":"search-button-container"}},[(!_vm.searchActive)?_c('div',{staticClass:"text-lg"},[_c('fa',{attrs:{"icon":['axis', 'search']}})],1):_c('div',[_c('input',{attrs:{"placeholder":"testing"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }